// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2kZwx","left":"InfoRow_left__beStN"};